import axios from 'axios';
import axiosInstance from '../axiosInstance';

export const getPathFeedSlides = async ({ includeInactive = false } = {}) => {
  const response = await axiosInstance.get('/pathfeed/slides', {
    params: { includeInactive },
  });
  return response.data.data || [];
};

export const createPathFeedSlide = async (data) => {
  const response = await axiosInstance.post('/pathfeed/slides', data);
  return response.data.data;
};

export const updatePathFeedSlide = async (slideId, data) => {
  const response = await axiosInstance.put(`/pathfeed/slides/${slideId}`, data);
  return response.data.data;
};

export const deletePathFeedSlide = async (slideId) => {
  await axiosInstance.delete(`/pathfeed/slides/${slideId}`);
};

export const getPathFeedSlideImageUploadUrl = async (fileName) => {
  const response = await axiosInstance.post(
    '/pathfeed/slides/admin/image-upload-url',
    null,
    { params: { fileName } },
  );
  return response.data.data;
};

export const uploadPathFeedSlideImage = async (file, uploadUrl) => {
  await axios.put(uploadUrl, file, {
    headers: { 'Content-Type': file.type },
  });
};
